import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import VariantesProveedorTable from "../VariantesProveedor/VariantesProveedorTable"
import { VariantesProveedorView } from "./VariantesProveedorView"
import { VariantesProveedorDelete } from "./VariantesProveedorDelete"
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import IconButton from '@mui/material/IconButton';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import authService from '../api-authorization/AuthorizeService'
import { Breadcrumbs } from '../General/Breadcrumbs';

export class VariantesProveedor_Index extends Component {
    static displayName = VariantesProveedor_Index.name;
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { retailVariantId: "", nombre: "", calibre_Id: 0, cajasPorPaleta_Id: 0, pais_Id: 0, },
            etiquetasCore: [],
            calibres: [],
            cajasPorPaleta: [],
            paises: [],
        };
        this.load_etiquetasCore = this.load_etiquetasCore.bind(this);
        this.load_calibres = this.load_calibres.bind(this);
        this.load_cajasPorPaleta = this.load_cajasPorPaleta.bind(this);
        this.load_paises = this.load_paises.bind(this);
        this.load_gridData = this.load_gridData.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modal_callback = this.modal_callback.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="retailVariantId">
                                        <FormattedMessage id='RetailVariantId' />
                                    </Label>
                                    <Input
                                        id="retailVariantId"
                                        name="retailVariantId"
                                        type="text"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.retailVariantId}
                                    />

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="nombre">
                                        <FormattedMessage id='VariantName' />
                                    </Label>
                                    <Input
                                        id="nombre"
                                        name="nombre"
                                        type="text"
                                        onChange={this.handleSearchChange}
                                        value={this.state.searchModel.nombre}
                                    />

                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="calibre_Id">
                                        <FormattedMessage id='Calibre' />
                                    </Label>
                                    <Input
                                        id="calibre_Id"
                                        name="calibre_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.calibres.map(calibre => calibre.calibre_Id == this.state.searchModel.calibre_Id ? (
                                            <option value={calibre.calibre_Id} selected>
                                                {calibre.calibre}
                                            </option>
                                        ) : (<option value={calibre.calibre_Id}>{calibre.calibre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="2">
                                <FormGroup>
                                    <Label for="cajasPorPaleta_Id">
                                        <FormattedMessage id='CajasPorPaleta' />
                                    </Label>
                                    <Input
                                        id="cajasPorPaleta_Id"
                                        name="cajasPorPaleta_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.cajasPorPaleta.map(cajasPorPaleta => cajasPorPaleta.cajasPorPaleta_Id == this.state.searchModel.cajasPorPaleta_Id ? (
                                            <option value={cajasPorPaleta.cajasPorPaleta_Id} selected>
                                                {cajasPorPaleta.cantidad}
                                            </option>
                                        ) : (<option value={cajasPorPaleta.cajasPorPaleta_Id}>{cajasPorPaleta.cantidad}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <VariantesProveedorTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = [
            { link: "/VariantesProveedor", message: "Administrar", active: true },
            { link: "/VariantesProveedor", message: "Variantes", active: false },
        ];
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div>
                <h2><FormattedMessage id='Variantes' /></h2>
                <Breadcrumbs data={breadcrumbsData} />
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true,
            etiquetasCore: await this.load_etiquetasCore(),
            calibres: await this.load_calibres(),
            cajasPorPaleta: await this.load_cajasPorPaleta(),
            paises: await this.load_paises(),
        }, async () => {
            this.setState({ data: await this.load_gridData(), loading: false });
        });
    }

    handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, () => {

        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><VariantesProveedorView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></VariantesProveedorView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/variantesProveedor', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.modal_callback()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesProveedor/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><VariantesProveedorView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></VariantesProveedorView></div>);
    }
    async edit_modal_guardar_onclick() {
        this.setState({
            loading: true,
            data: await this.load_gridData()
        }, async () => {
            const token = await authService.getAccessToken();
            const data = JSON.stringify(this.modalBodyState);
            const varianteProveedor_Id = this.modalBodyState.varianteProveedor_Id ?? 0;
            console.log("varianteProveedor_Id", varianteProveedor_Id)
            const response = await fetch('api/variantesProveedor/' + varianteProveedor_Id, {
                method: 'PUT',
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: data
            });
            if (response.ok) {
                this.modalToggle();
                await this.modal_callback()
            }
        });
        
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesProveedor/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><VariantesProveedorDelete setModalBodyState={this.setModalBodyState} data={responceData}></VariantesProveedorDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/variantesProveedor/' + this.modalBodyState.varianteProveedor_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.modal_callback()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { nombre: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async modal_callback() {
        this.setState({
            loading: true,
            data: await this.load_gridData()
        }, async () => {
            this.setState({ loading: false });
        });
    }
    async load_gridData() {
        const token = await authService.getAccessToken();
        var queryString = '?';
        Object.keys(this.state.searchModel).forEach(key => {
            queryString += key + "=" + this.state.searchModel[key] + "&";
        });
        queryString = queryString.slice(0, -1);
        const response = await fetch('api/variantesProveedor' + queryString, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    }
    async load_etiquetasCore() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/etiquetasCore/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_calibres() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/calibres/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cajasPorPaleta() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/cajasPorPaleta/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_paises() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paises/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
}